import { Grid, Stack, Typography } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import ClearIcon from "@mui/icons-material/Clear";
import { black, blue } from "@/theme/colors";
import { useFormContext, useWatch } from "react-hook-form";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { useEffect, useMemo, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { ConfirmDeleteModal } from "@/components/commons/ConfirmDeleteModal";

export const TalentFormHeldQualificationsFields = () => {
  const { control, setValue } = useFormContext<TTalentForm>();
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const heldQualifications = useWatch({ control, name: "heldQualifications" }) || [""];

  const hasEmptyField = useMemo(() => heldQualifications.some((value) => !value || value.trim() === ""), [heldQualifications]);

  const handleAddField = () => {
    if (heldQualifications.length < 10 && !hasEmptyField) {
      setValue("heldQualifications", [...heldQualifications, ""]);
    }
  };

  const handleRemoveField = (index: number) => {
    if (heldQualifications.length > 1) {
      const value = heldQualifications[index];
      if (!value || value.trim() === "") {
        const updated = heldQualifications.filter((_, i) => i !== index);
        setValue("heldQualifications", updated);
      } else {
        setDeleteIndex(index);
        setIsDeleteModalOpen(true);
      }
    }
  };

  const confirmDelete = () => {
    if (deleteIndex !== null && heldQualifications.length > 1) {
      const updated = heldQualifications.filter((_, i) => i !== deleteIndex);
      setValue("heldQualifications", updated);
    }
    setIsDeleteModalOpen(false);
    setDeleteIndex(null);
  };

  useEffect(() => {
    if (!heldQualifications || heldQualifications.length === 0) {
      setValue("heldQualifications", [""]);
    }
  }, [heldQualifications, setValue]);

  return (
    <>
      <Stack mt={2}>
        <Typography variant="cap12" sx={{ mb: 1 }}>
          資格
        </Typography>

        {heldQualifications.map((_, index) => (
          <Grid container spacing={3} key={index} sx={{ mb: heldQualifications.length - 1 === index ? 0 : 2 }}>
            <Grid item xs={12}>
              <FormField control={control} name={`heldQualifications.${index}`}>
                <Input placeholder="入力してください" />
              </FormField>
            </Grid>

            {heldQualifications.length > 1 && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={0.5}
                sx={{ cursor: "pointer", mt: 1, ml: 3 }}
                onClick={() => handleRemoveField(index)}
              >
                <ClearIcon sx={{ color: black[80], fontSize: 18 }} />
                <Typography variant="cap12Light">削除</Typography>
              </Stack>
            )}
          </Grid>
        ))}

        {heldQualifications.length < 10 && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            mt={2}
            sx={{
              cursor: hasEmptyField ? "not-allowed" : "pointer",
              opacity: hasEmptyField ? 0.5 : 1,
            }}
            onClick={handleAddField}
          >
            <AddCircleOutlineIcon
              sx={{
                color: hasEmptyField ? black[60] : blue[80],
                fontSize: 18,
              }}
            />
            <Typography variant="cap12">資格を追加</Typography>
          </Stack>
        )}
      </Stack>

      <ConfirmDeleteModal
        open={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setDeleteIndex(null);
        }}
        onOk={confirmDelete}
        message="「資格」を削除してもよろしいですか？"
      />
    </>
  );
};
